import { render, staticRenderFns } from "./AccidentEventInfo.vue?vue&type=template&id=2e0bfb60&scoped=true"
import script from "./AccidentEventInfo.vue?vue&type=script&lang=js"
export * from "./AccidentEventInfo.vue?vue&type=script&lang=js"
import style0 from "./AccidentEventInfo.vue?vue&type=style&index=0&id=2e0bfb60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0bfb60",
  null
  
)

export default component.exports